import { Routes } from '@angular/router';
import { fileGuard } from './core/guards/file/file-guard';
import { processGuard } from './core/guards/process/process-guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes/unsaved-changes.guard';
import { pageVersionRedirectGuard } from './core/guards/page-version/page-version-redirect.guard';
import { authGuard } from './core/guards/auth/auth.guard';

const versionedPageGuard = [pageVersionRedirectGuard];

export const routes: Routes = [
  {
    path: 'login',
    title: 'Rate Sheet Agent | Sign In',
    loadComponent: () => import('./feature/login/login').then(m => m.Login)
  },
  {
    path: 'auth-error',
    title: 'Rate Sheet Agent | Authentication Error',
    loadComponent: () => import('./feature/auth-error/auth-error').then(m => m.AuthError)
  },
  {
  path: '',
  canActivate: [authGuard],
  loadComponent: () => import('./feature/layout/layout').then(l=>l.Layout),
  loadChildren: ()=>[
    {
      path:'',
      redirectTo: 'dashboard',
      pathMatch: 'full'
    },
    {
      path: 'home',
      title: 'Rate Sheet Agent | Start',
      loadComponent: () => import('./feature/home/home').then(h=>h.Home)
    },
    {
      path: 'upload',
      title: 'Rate Sheet Agent | Start',
      loadComponent: () => import('./feature/home/home').then(h=>h.Home)
    },
    {
      path:'file',
      canActivate:[fileGuard, processGuard],
      loadComponent: () => import('./feature/file-processing/file-processing').then(f=>f.FileProcessing)
    },
    {
      path:'process',
      canActivate:[processGuard, ...versionedPageGuard],
      canDeactivate:[unsavedChangesGuard],
      title: 'Rate Sheet Agent | Training',
      loadComponent: () => import('./feature/mapper/mapper').then(p=>p.Mapper)
    },
    {
      path:'process-v2',
      canActivate:[processGuard, ...versionedPageGuard],
      canDeactivate:[unsavedChangesGuard],
      title: 'Rate Sheet Agent | Training V2',
      loadComponent: () => import('./feature/mapper-v2/mapper-v2').then(p=>p.MapperV2)
    },
    {
      path:'history',
      redirectTo: 'dashboard',
      pathMatch: 'full'
    },
    {
      path:'history/:coId',
      redirectTo: 'dashboard',
      pathMatch: 'full'
    },
    {
      path: 'dashboard',
      title: 'Rate Sheet Agent | Dashboard',
      loadComponent: () => import('./feature/dashboard/dashboard').then(d => d.Dashboard),
      children: [
        {
          path: 'history/:coId',
          title: 'Rate Sheet Agent | History',
          loadComponent: () => import('./feature/history/history').then(h => h.HistoryViewer)
        }
      ]
    },
    {
      path: 'dashboard-2',
      title: 'Rate Sheet Agent | Dashboard 2',
      canActivate: versionedPageGuard,
      loadComponent: () => import('./feature/dashboard-two/dashboard-two').then(d => d.DashboardTwo)
    },
    {
      path: 'validation-dashboard-v2',
      title: 'Rate Sheet Agent | Validation Dashboard V2',
      canActivate: versionedPageGuard,
      loadComponent: () => import('./feature/validation-dashboard-v2/validation-dashboard-v2').then(d => d.ValidationDashboardV2)
    },
    {
      path: 'analytics-studio',
      title: 'Rate Sheet Agent | Live Analytics',
      loadComponent: () => import('./feature/analytics-studio/analytics-studio').then(m => m.AnalyticsStudio)
    },
    {
      path: 'analytics-studio-classic',
      title: 'Rate Sheet Agent | Analytics Studio',
      loadComponent: () => import('./feature/analytics-studio-classic/analytics-studio-classic').then(m => m.AnalyticsStudioClassic)
    },
    {
      path: 'oem-clone',
      title: 'Rate Sheet Agent | Add OEM',
      loadComponent: () => import('./feature/oem-clone/oem-clone').then(o => o.OemClone)
    },
    {
      path: 'upload-review',
      canActivate: [fileGuard, processGuard],
      canDeactivate: [unsavedChangesGuard],
      title: 'Rate Sheet Agent | Review Upload',
      loadComponent: () =>
        import('./feature/upload-review/upload-review').then(m => m.UploadReview)
    },
    {
      path: 'validation',
      title: 'Rate Sheet Agent | Validation',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/validation-summary/validation-summary')
          .then(m => m.ValidationSummary)
    },
    {
      path: 'register-validation',
      title: 'Rate Sheet Agent | Register Validation',
      loadComponent: () =>
        import('./feature/register-validation/register-validation')
          .then(m => m.RegisterValidation)
    },
    {
      path: 'validation-run/:runId',
      title: 'Rate Sheet Agent | Validation Run Workbench',
      loadComponent: () =>
        import('./feature/validation-run-workbench/validation-run-workbench')
          .then(m => m.ValidationRunWorkbench)
    },
    {
      path: 'validation-run/:runId/approval',
      title: 'Rate Sheet Agent | Approval & Promote',
      loadComponent: () =>
        import('./feature/run-approval-promote/run-approval-promote')
          .then(m => m.RunApprovalPromote)
    },
    {
      path: 'validation-v2',
      title: 'Rate Sheet Agent | Validation V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/validation-summary-v2/validation-summary-v2')
          .then(m => m.ValidationSummaryV2)
    },
    {
      path: 'validation-progress',
      title: 'Rate Sheet Agent | Validation Progress',
      loadComponent: () =>
        import('./feature/validation-progress-page/validation-progress-page')
          .then(m => m.ValidationProgressPage)
    },
    {
      path: 'validation-progress/:runId',
      title: 'Rate Sheet Agent | Validation Progress',
      loadComponent: () =>
        import('./feature/validation-progress-page/validation-progress-page')
          .then(m => m.ValidationProgressPage)
    },
    {
      path: 'validation/rule-failures',
      title: 'Rate Sheet Agent | Rule Failure Detail',
      loadComponent: () =>
        import('./feature/validation-rule-failures/validation-rule-failures')
          .then(m => m.ValidationRuleFailures)
    },
    {
      path: 'compare',
      title: 'Rate Sheet Agent | Compare Runs',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/run-compare/run-compare')
          .then(m => m.RunCompare)
    },
    {
      path: 'compare-v2',
      title: 'Rate Sheet Agent | Compare Runs V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/run-compare-v2/run-compare-v2')
          .then(m => m.RunCompareV2)
    },
    {
      path: 'promotion',
      title: 'Rate Sheet Agent | Promotion Console',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/promotion-console/promotion-console')
          .then(m => m.PromotionConsole)
    },
    {
      path: 'promotion-v2',
      title: 'Rate Sheet Agent | Promotion Console V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/promotion-console-v2/promotion-console-v2')
          .then(m => m.PromotionConsoleV2)
    },
    {
      path: 'review',
      title: 'Rate Sheet Agent | Approval Workflow',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/approval-workflow/approval-workflow')
          .then(m => m.ApprovalWorkflow)
    },
    {
      path: 'review-v2',
      title: 'Rate Sheet Agent | Approval Workflow V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/approval-workflow-v2/approval-workflow-v2')
          .then(m => m.ApprovalWorkflowV2)
    },
    {
      path: 'settings',
      title: 'Rate Sheet Agent | Settings',
      loadComponent: () =>
        import('./feature/settings/settings')
          .then(m => m.Settings)
    },
    {
      path: 'upload-center',
      title: 'Rate Sheet Agent | Upload Center',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/upload-center/upload-center')
          .then(m => m.UploadCenter)
    },
    {
      path: 'upload-center-v2',
      title: 'Rate Sheet Agent | Upload Center V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/upload-center-v2/upload-center-v2')
          .then(m => m.UploadCenterV2)
    },
    {
      path: 'upload-center-v2/transfer/:guid',
      title: 'Rate Sheet Agent | Sheet Transfer Mapping V2',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/upload-transfer-v2/upload-transfer-v2')
          .then(m => m.UploadTransferV2)
    },
    {
      path: 'upload-center/transfer/:guid',
      title: 'Rate Sheet Agent | Sheet Transfer Mapping',
      canActivate: versionedPageGuard,
      loadComponent: () =>
        import('./feature/upload-transfer/upload-transfer')
          .then(m => m.UploadTransfer)
    },
    {
      path: 'preview',
      canActivate:[processGuard],
      canDeactivate:[unsavedChangesGuard],
      title: 'Rate Sheet Agent | UnifiExcel',
      loadComponent: () => import('./feature/file-data-preview/file-data-preview').then(p=>p.FileDataPreview)
    },
    {
      path: 'validation-rules',
      title: 'Rate Sheet Agent | Validation Rules',
      loadComponent: () =>
        import('./feature/validation-rules/validation-rules')
          .then(m => m.ValidationRules)
    },
    {
      path: 'exceptions',
      title: 'Rate Sheet Agent | Exception Review',
      loadComponent: () =>
        import('./feature/exceptions/exceptions')
          .then(m => m.Exceptions)
    },
    {
      path: '**',
      redirectTo: 'dashboard'
    }
  ]
 }
];
